import { IMenuConfig, ILabel, ICursorConfig, IAssetsConfig, IButton } from "../types/game-config-type";
import { IMenuCommand } from "./commands/menu-command";
import { Assets } from "../game/resources";
import { table } from "../game/table";
import { GameConfig } from "../config/game-config";
import { MenuActionType } from "./menu-action-type";
import { MenuLabel } from "./menu-label";
import gameApplication from "../game/game-app";
import { store } from "../stores";
import { MenuButton } from "./menu-button";

const cursorConfig: ICursorConfig = GameConfig.cursor;
const sprites: IAssetsConfig = GameConfig.sprites;

export class Menu {
  private labels: MenuLabel[];
  private buttons: MenuButton[]

  private isActive: boolean;

  public set active(value: boolean) {
    this.isActive = value;
  }

  public get active(): boolean {
    return this.isActive;
  }

  public init(actionsMap: Map<MenuActionType, IMenuCommand>, config: IMenuConfig): void { 
    this.buttons = config.buttons.map((button: IButton) => {
      return new MenuButton(
          null,
          button.value,
          button.position, 
          button.sprite, 
          button.spriteOnHover,
        );
    });
    
    this.labels = config.labels.map((label: ILabel) => {
      return new MenuLabel(label.text, label.position,
        label.font, label.color, label.alignment);
    });
  }

  public update(): void {
  }

  public draw(): void {
    if (this.isActive) {
      const gameKind = gameApplication.getGameKind();
      table.changeCursor(cursorConfig.default);
      
      if (gameKind === 'PRACTICE') {
        if (store.state.settings.defaultPracticeGame === 'POOL8' ||
          store.state.settings.defaultPracticeGame === 'POOL9' ||
          store.state.settings.defaultPracticeGame === 'POOL8UK'
        ) {
          table.drawImage(Assets.getSprite(sprites.paths.menuBackground));
        }
        else if (store.state.settings.defaultPracticeGame === 'SNOOKER' ||
          store.state.settings.defaultPracticeGame === 'SNOOKER6') {
          table.drawImage(Assets.getSprite(sprites.paths.menuBackground2));
        } 
      }
      else if (gameKind === 'POOL8' || gameKind === 'POOL9' || gameKind === 'POOL8UK') {
        table.drawImage(Assets.getSprite(sprites.paths.menuBackground));
      }
      else if (gameKind === 'SNOOKER' || gameKind === 'SNOOKER6') {
        table.drawImage(Assets.getSprite(sprites.paths.menuBackground2));
      }

      this.buttons.forEach((button: MenuButton) => button.draw());
      this.labels.forEach((label: MenuLabel) => label.draw());    
    }
  }
}
